import { useEffect, useRef, useState } from 'react';
var useHover = function () {
    var ref = useRef(null);
    var _a = useState(false), isHovered = _a[0], setIsHovered = _a[1];
    var handleMouseEnter = function () { return setIsHovered(true); };
    var handleMouseLeave = function () { return setIsHovered(false); };
    useEffect(function () {
        var element = ref.current;
        if (element) {
            element.addEventListener('mouseenter', handleMouseEnter);
            element.addEventListener('mouseleave', handleMouseLeave);
            return function () {
                element.removeEventListener('mouseenter', handleMouseEnter);
                element.removeEventListener('mouseleave', handleMouseLeave);
            };
        }
    }, [ref.current]);
    return [ref, isHovered];
};
export default useHover;
//# sourceMappingURL=useHover.js.map